import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

// Global error handler for browser extension errors
window.addEventListener('error', (e) => {
  if (e.message?.includes('addListener') || e.filename?.includes('chrome-extension')) {
    console.warn('Ignored browser extension error:', e.message);
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('addListener')) {
    console.warn('Ignored extension promise rejection');
    e.preventDefault();
    return false;
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
